const handleModShopRedirect = () => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('return-from-customizer') === 'true') {
      window.showModal(
        "<p style='padding: 60px;'><strong>Sorry</strong>, Fender Mod Shop is currently not available for your region. Sign up below for our newsletter to be among the first to hear when Mod Shop is available.</p>"
      );
    }
  };

window.addEventListener('load', handleModShopRedirect);
